// NotFoundState.tsx — designed 404 for unmatched routes (audit-2026-07 U1).
// Renders inside the root layout (MainNav stays), replacing TanStack's raw
// "Not Found" fallback. Voice: brand.md §3 empty-state tone — orienting,
// one next action.

import { useNavigate } from '@tanstack/react-router';
import { Compass } from '@/components/Icon';
import { useDocumentTitle } from '@/lib/use-document-title';
import { EmptyState } from './EmptyState';

export function NotFoundState(): JSX.Element {
  const navigate = useNavigate();
  useDocumentTitle('Studio · Not found');
  return (
    <main id="main" tabIndex={-1} className="mx-auto w-full max-w-4xl px-4 py-6">
      <EmptyState
        icon={Compass}
        title="No lane at this address"
        description="The route you followed doesn't exist. The day's queue is in Today."
        cta={{ label: 'Go to Today', onClick: () => void navigate({ to: '/today' }) }}
      />
    </main>
  );
}
